import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import axios from "axios";
import ConsignmentCumulativeFreightTable from "./ConsignmentCumulativeFreightTable";
const ConsignmentCumulativeFreightModal = (props) => {
    const [loading, setLoading] = useState(false);
    const [cumulativeTotals, setCumulativeTotals] = useState([]);
    useEffect(() => {
        if (props.open) {
            if (props.consignmentId) {
                setLoading(true);
                axios.get(`/admin/v1/consignments/${props.consignmentId}/cumulative-freight`)
                    .then((response) => {
                    if (response.status === 200) {
                        setCumulativeTotals(response.data);
                    }
                    if (response.status === 204) { // "No-Content"
                        setCumulativeTotals([]);
                    }
                })
                    .finally(() => {
                    setLoading(false);
                });
            }
        }
        else {
            setCumulativeTotals([]);
        }
    }, [props.open, props.consignmentId]);
    return (_jsxs(Modal, { open: props.open, onCancel: props.onClose, title: "Cumulative Totals", loading: loading, width: 800, footer: [
            _jsx(Button, { htmlType: "button", onClick: props.onClose, children: "Close" }, "close")
        ], children: [_jsx("p", { children: "All freight to be delivered to the same address and delivery day" }), _jsx(ConsignmentCumulativeFreightTable, { loading: loading, cumulativeTotals: cumulativeTotals })] }));
};
export default ConsignmentCumulativeFreightModal;
